'use strict';


module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it/index.js
// module id = 1547
// module chunks = 0